import { render } from "./PayPopup.vue?vue&type=template&id=2ac252fb&ts=true"
import script from "./PayPopup.vue?vue&type=script&lang=ts"
export * from "./PayPopup.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/vav/Dev/eco-lk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__